/**
 * @module app.bdc.list.formConfirmDeleteCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FormConfirmDeleteCtrl($scope, $uibModalInstance, $log) {
        var self = {};

        self.delete = function() {
            $uibModalInstance.close(true);
        };

        self.doNotDelete = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    FormConfirmDeleteCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular
        .module('app.bdc.list.formConfirmDeleteCtrl', ['ui.bootstrap.modal'])
        .controller('FormConfirmDeleteCtrl', FormConfirmDeleteCtrl);
});
